import {LOADED_PERFORMANCE_CONFIGS, SET_PERFORMANCE_MENU_DISTRICT_ID} from "../actions/performance_actions";

const performance_configs = (payload = [], action) => {
    switch (action.type) {
        case LOADED_PERFORMANCE_CONFIGS:
            return action.payload;
        default:
            return payload;
    }
};
const performance_menu_district_id = (payload = null, action) => {
    switch (action.type) {
        case SET_PERFORMANCE_MENU_DISTRICT_ID:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    performance_configs,
    performance_menu_district_id
}
